import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { AppNavigationService } from '@assetaccountant/core';
import { RegisterService } from '@assetaccountant/core/services/register.service';
import { TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';

import { EnabledAndDisabledPools } from './model/enabled-pools';

@Component({
  selector: 'app-pool-setting-selection',
  templateUrl: './pool-setting-selection.component.html',
  styleUrls: ['./pool-setting-selection.component.scss'],
  standalone: false,
})
export class PoolSettingSelectionComponent implements OnInit {
  @ViewChild('ngForm') ngForm: NgForm;
  form = this.fb.group({
    groupSelections: this.fb.group({} as { [groupKey: string]: [string] }),
    otherSelections: this.fb.group({} as { [key: string]: [boolean] }),
  });

  @Output() onSaved = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  readonly RegisterPermission = RegisterPermissionType;

  pool: EnabledAndDisabledPools;

  constructor(
    private fb: TypedFormBuilder,
    private registerService: RegisterService,
    private appNavigationService: AppNavigationService,
  ) {}

  ngOnInit() {
    this.registerService
      .getPoolSettings(this.appNavigationService.getActiveRegister().id)
      .subscribe(poolSettings => {
        this.loadPoolSettings(poolSettings);
      });
  }

  loadPoolSettings(model: EnabledAndDisabledPools) {
    this.pool = model;
    for (const groupedList of model.poolGroups) {
      this.form.controls.groupSelections.addControl(
        groupedList.groupKey,
        this.fb.control(groupedList.enabledItemCode),
      );
    }
    for (const item of model.pools) {
      this.form.controls.otherSelections.addControl(item.code, this.fb.control(item.enabled));
    }
  }

  cancel() {
    this.onCancel.emit();
  }

  get hasSelectedItems() {
    if (!this.pool) {
      return false;
    }

    for (const poolGroup of this.pool.poolGroups) {
      if (this.form.value.groupSelections[poolGroup.groupKey]) {
        return true;
      }
    }
    for (const pool of this.pool.pools) {
      if (this.form.value.otherSelections[pool.code]) {
        return true;
      }
    }
    return false;
  }

  get hasNoSelectedItems() {
    return !this.hasSelectedItems;
  }

  submit() {
    this.ngForm.ngSubmit.emit();
  }

  save() {
    for (const poolGroup of this.pool.poolGroups) {
      poolGroup.enabledItemCode = this.form.value.groupSelections[poolGroup.groupKey];
    }
    for (const pool of this.pool.pools) {
      pool.enabled = this.form.value.otherSelections[pool.code];
    }

    this.registerService
      .savePoolSettings(this.appNavigationService.getActiveRegister().id, this.pool)
      .subscribe(_ => {
        this.form.markAsPristine();
        this.onSaved.emit();
      });
  }
}
